import angular from 'angular';

export default function EditReportPackageDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  alerts,
  docDataService,
  reportsDataService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isReportsExpanded = true;
  vm.itemsLoaded = false;

  vm.handleNameChange = _handleNameChange;
  vm.handleGeneratePackage = handleGeneratePackage;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = true;
    const dfdActivate = $q.defer();

    _loadReportInstances().then(() => {
      vm.itemsLoaded = true;
      dfdActivate.resolve();
      loaderService.showViewLoader = false;
    });

    return dfdActivate.promise;
  }

  function _handleNameChange() {
    const dfdSave = $q.defer();
    const dfdHideDialog = $q.defer();

    if (_isValid()) {
      reportsDataService.saveReportPackage(vm.reportPackage).then((response) => {
        const savedReportPackage = response.data;
        if (savedReportPackage.reportPackageId === 'undefined' || savedReportPackage.reportPackageId <= 0) {
          // There was an error saving the Report Package information
          alerts.error('Error occurred while saving the Report Package Name.');
          dfdSave.reject();
        } else {
          // The reportPackage information has been saved
          vm.reportPackage = savedReportPackage;
          alerts.success('The Report Package Name has been saved successfully.');
          dfdHideDialog.resolve();
        }
      });

      dfdHideDialog.promise.then(dfdSave.resolve);
    } else {
      dfdSave.reject();
    }
    return dfdSave.promise;
  }

  function _isValid() {
    let isValid = $scope.prEditReportPackageForm.$valid;

    if (!isValid) {
      isValid = true;
      angular.forEach($scope.prEditReportPackageForm.$error.parse, () => {
        isValid = false;
      });
      angular.forEach($scope.prEditReportPackageForm.$error.pattern, () => {
        isValid = false;
      });
      angular.forEach($scope.prEditReportPackageForm.$error.required, () => {
        isValid = false;
      });
    }
    return isValid;
  }

  function handleGeneratePackage() {
    return reportsDataService.createPackageFileGenerationRequest(vm.reportPackage.reportPackageId).then(() => {
      alerts.success('The Report Package has been successfully requested. '
        + 'You will receive an email notification when the file generation is complete.');
    });
  }

  function _handleCloseDialog() {
    $rootScope.$broadcast('refreshReportPackages');
    ssDialogService.hide(ssDialogService.dialogs.reports.editReportPackageDialog);
  }

  function _loadReportInstances() {
    loaderService.showViewLoader = true;
    const dfdRefresh = $q.defer();

    const dfdFinancialInstitutionReports = docDataService.getCustomerReportInstances();
    const dfdMyReports = docDataService.getUserReportInstances();
    const dfdArchivedReports = docDataService.getArchivedReportInstances();

    $q.all([
      dfdFinancialInstitutionReports,
      dfdMyReports,
      dfdArchivedReports
    ]).then((responses) => {
      vm.fiReportFolders = responses[0].data;
      vm.myReportFolders = responses[1].data;
      vm.archivedReportFolders = responses[2].data;
      loaderService.showViewLoader = false;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }
}

EditReportPackageDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'alerts',
  'docDataService',
  'reportsDataService'
];
